import { ChangeDetectionStrategy, Component, DestroyRef, input, OnDestroy } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Observable, switchMap } from 'rxjs';
import { WhereUsedState, WhereUsedStore } from './where-used.store';
import { formatNumber } from '../../../../../utils/format-amount';

@Component({
  selector: 'where-used',
  templateUrl: './where-used.component.html',
  styleUrl: './where-used.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, RouterLink]
})
// The card follows the bomItemId input: every change re-inits the store (switchMap drops stale in-flight responses)
export class WhereUsedComponent implements OnDestroy {
  readonly bomItemId = input.required<number | undefined>();

  formatNumber = formatNumber;

  readonly state$: Observable<WhereUsedState>;

  constructor(
    private store: WhereUsedStore,
    private destroyRef: DestroyRef
  ) {
    this.state$ = this.store.state$;

    toObservable(this.bomItemId)
      .pipe(
        switchMap(bomItemId => this.store.init(bomItemId)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.store.destroy();
  }
}
